module.exports = __webpack_public_path__ + "static/media/left-arrow-purple.5f87ab3f.svg";